import React, { useState } from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css'; // Ensure you have this in your project
import shock from '../assets/css/img/shock.png'


const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const mailtoLink = `mailto:ram@axissolar.in?subject=${encodeURIComponent(formData.subject)}&body=${encodeURIComponent(formData.message)}`;
    const newTab = window.open(mailtoLink, '_blank');
    if (newTab) {
      newTab.opener = null;
    }

    // Reset form data to clear the inputs
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: ''
    });
  };

  return (
    <section id="Contact" className="contact section">
      <div className="container section-title" data-aos="fade-up">
      <h1 className="p-4 green-heading text-center"><img src={shock} className='shock'/>&nbsp;Contact Us</h1>
      </div>

      <div className="container" data-aos="fade" data-aos-delay="100">
        <div className="row gy-4">
          <div className="col-lg-4">
            <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="200">
              <i className="bi bi-geo-alt flex-shrink-0"></i>
              <div>
                <h3>Address</h3>
                <p> <a href="https://www.google.com/maps/place/Axis+Solar+Systems/@17.4754099,78.4270006,54m/data=!3m1!1e3!4m14!1m7!3m6!1s0x3bcb9163085fe249:0x66faba920b8d1842!2sSONY+COMPLEX!8m2!3d17.4753666!4d78.4269256!16s%2Fg%2F11pm4pdpgk!3m5!1s0x3bcb91aba0874d03:0x827487f49f819449!8m2!3d17.4753114!4d78.4268712!16s%2Fg%2F11b_2v9cmh!5m1!1e1?entry=ttu&g_ep=EgoyMDI1MTIwNy4wIKXMDSoASAFQAw%3D%3D" target='_blank' style={{lineHeight:"1.7em"}}> Shop No. 10, Sony Complex, Prashanthi <br />Nagar,
                Ind. Estate, Kukatpally,<br></br> Hyderabad, Telangana 500072</a></p>
              </div>
            </div>

            <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="300">
              <i className="bi bi-telephone flex-shrink-0"></i>
              <div>
                <h3>Call Us</h3>
                <p><a href="tel:+918999999108"target='_blank'>+91 8999999108</a></p>
              </div>
            </div>

            <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="400">
              <i className="bi bi-envelope flex-shrink-0"></i>
              <div>
                <h3>Email Us</h3>
                <p><a href="mailto:ram@axissolar.in" target='_blank'>ram@axissolar.in</a></p>
              </div>
            </div>
          </div>

          <div className="col-lg-8">
            <form onSubmit={handleSubmit} className="php-email-form" data-aos="fade-up" data-aos-delay="200">
              <div className="row gy-4">
                <div className="col-md-6">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-md-6">
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-md-12">
                  <input
                    type="text"
                    name="subject"
                    className="form-control"
                    placeholder="Subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-md-12">
                  <textarea
                    name="message"
                    className="form-control"
                    rows="6"
                    placeholder="Message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-md-12 text-center">
                  <button type="submit">Send Message</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;